module.exports = __webpack_public_path__ + "static/media/order-ico-01.5964105d.svg";